import React from "react";

const SimplePagination = ({ currentPage, setCurrentPage, totalPages }) => {

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
  };

  // Generate page numbers to display
 const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }

    return pages;
  };

  return (
    <div
      className="pagination"
      style={{ display: "flex", justifyContent: "center", gap: "5px" }}
    >
      {/* Prev Button */}
      <button
      type="button"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={{
          border: "1px solid #ddd",
          padding: "0 8px",
          cursor: currentPage > 1 ? "pointer" : "not-allowed",
          borderRadius: "4px",
          opacity: currentPage > 1 ? "1" : "0.5",
          backgroundColor: "#f0f0f0",
          color: "black",
        }}
      >
        Prev
      </button>

      {/* Page Numbers */}
      {getPageNumbers().map((page, idx) =>
        page === "..." ? (
          <span key={idx} style={{ padding: "0 8px" }}>...</span>
        ) : (
          <button
           type="button"
            key={idx}
            onClick={() => handlePageChange(page)}
            style={{
              border: "1px solid #ddd",
              padding: "0 8px",
              cursor: "pointer",
              borderRadius: "4px",
              backgroundColor: currentPage === page ? "var(--mainCol)" : "#f0f0f0",
              color: currentPage === page ? "white" : "black",
            }}
          >
            {page}
          </button>
        )
      )}

      {/* Next Button */}
      <button
       type="button"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        style={{
          border: "1px solid #ddd",
          padding: "0 8px",
          cursor: currentPage < totalPages ? "pointer" : "not-allowed",
          borderRadius: "4px",
          opacity: currentPage < totalPages ? "1" : "0.5",
          backgroundColor: "#f0f0f0",
          color: "black",
        }}
      >
        Next
      </button>
    </div>
  );
};

export default SimplePagination;